export default function Footer() {
  const scroll = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#111111] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <a href="/" data-testid="footer-logo" className="font-heading text-2xl font-black tracking-tighter text-[#F2EFE9]">
              3<span className="text-[#D4AF37]">SM</span>
            </a>
            <p className="text-sm text-[#8C8C8C] font-body mt-3 leading-relaxed max-w-xs">
              A trauma-informed training system built around Strength, Self-Defense, and Striking Mindset. A System. Not a Place.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-[#F2EFE9] mb-4 uppercase tracking-wider">Navigate</h4>
            <div className="space-y-2">
              {[
                ["About", "#why"],
                ["The 3SM Method", "#method"],
                ["Programs", "#offers"],
                ["Community Impact", "#community"],
                ["Testimonials", "#testimonials"],
                ["FAQ", "#faq"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <button
                  key={href}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  onClick={() => scroll(href)}
                  className="block text-sm text-[#8C8C8C] hover:text-[#D4AF37] transition-colors font-body"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-[#F2EFE9] mb-4 uppercase tracking-wider">Connect</h4>
            <div className="space-y-2 text-sm text-[#8C8C8C] font-body">
              <p data-testid="footer-location" className="leading-relaxed">
                Private sessions available by appointment at 301 Texas St., Dallas, TX 75204.
              </p>
              <a href="tel:2146006027" data-testid="footer-phone" className="block hover:text-[#D4AF37] transition-colors">(214) 600-6027</a>
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#D4AF37]/70 font-body pt-2">
                A System. Not a Place.
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#8C8C8C] font-body">&copy; {year} 3SM. All rights reserved.</p>
          <a
            href="/admin/login"
            data-testid="footer-admin-link"
            className="text-xs text-[#8C8C8C]/50 hover:text-[#8C8C8C] transition-colors font-body"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
